import axios from 'axios';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var AzureSearchApiSettings = function AzureSearchApiSettings(settings) {
    classCallCheck(this, AzureSearchApiSettings);

    this.searchServiceName = null;
    this.searchServiceAdminApiKey = null;
    this.searchServiceQueryApiKey = null;
    this.indexName = null;
    this.apiVersion = '2017-11-11';
    this.url = null;
    this.corsSettings = [];
    if (settings) {
        if (settings.searchServiceName) this.searchServiceName = settings.searchServiceName;
        if (settings.searchServiceAdminApiKey) this.searchServiceAdminApiKey = settings.searchServiceAdminApiKey;
        if (settings.searchServiceQueryApiKey) this.searchServiceQueryApiKey = settings.searchServiceQueryApiKey;
        if (settings.indexName) this.indexName = settings.indexName;
        if (settings.apiVersion) this.apiVersion = settings.apiVersion;
        if (settings.url) this.url = settings.url;
        if (settings.corsSettings) this.corsSettings = settings.corsSettings;
    }
};

var AzureSearchRequest = function () {
    function AzureSearchRequest(settings) {
        classCallCheck(this, AzureSearchRequest);

        this.search = '*';
        this.select = null;
        this.filter = null;
        this.queryType = 'full';
        this.orderBy = null;
        this.top = null;
        this.skip = null;
        this.count = null;
        this.facets = [];
        this.highlight = null;
        this.highlightPreTag = null;
        this.highlightPostTag = null;
        this.scoringProfile = null;
        if (settings) {
            if (settings.search) this.search = settings.search;
            if (settings.select) this.select = settings.select;
            if (settings.filter) this.filter = settings.filter;
            if (settings.queryType) this.queryType = settings.queryType;
            if (settings.orderBy) this.orderBy = settings.orderBy;
            if (settings.top !== undefined && settings.top !== null) this.top = settings.top;
            if (settings.skip !== undefined && settings.skip !== null) this.skip = settings.skip;
            if (settings.count !== undefined && settings.count !== null) this.count = settings.count;
            if (settings.facets) this.facets = settings.facets;
            if (settings.highlight) this.highlight = settings.highlight;
            if (settings.highlightPreTag) this.highlightPreTag = settings.highlightPreTag;
            if (settings.highlightPostTag) this.highlightPostTag = settings.highlightPostTag;
            if (settings.scoringProfile) this.scoringProfile = settings.scoringProfile;
        }
    }

    createClass(AzureSearchRequest, [{
        key: 'getSearchRequestBody',
        value: function getSearchRequestBody() {
            var requestBody = {};
            if (this.search) requestBody.search = this.search;
            if (this.select) requestBody.select = this.select;
            if (this.filter) requestBody.filter = this.filter;
            if (this.queryType) requestBody.queryType = this.queryType;
            if (this.orderBy) requestBody.orderby = this.orderBy;
            if (this.top !== undefined && this.top !== null) requestBody.top = this.top;
            if (this.skip !== undefined && this.skip !== null) requestBody.skip = this.skip;
            if (this.count !== undefined && this.count !== null) requestBody.count = this.count;
            if (this.facets) requestBody.facets = this.facets;
            if (this.highlight) requestBody.highlight = this.highlight;
            if (this.highlightPreTag) requestBody.highlightPreTag = this.highlightPreTag;
            if (this.highlightPostTag) requestBody.highlightPostTag = this.highlightPostTag;
            if (this.scoringProfile) requestBody.scoringProfile = this.scoringProfile;
            return requestBody;
        }
    }]);
    return AzureSearchRequest;
}();

var AzureSearchGui = function AzureSearchGui(settings) {
    classCallCheck(this, AzureSearchGui);

    this.showFacets = true;
    this.showSearchBar = false;
    this.executeSearchOnLoad = true;
    this.Page = 1;
    if (settings) {
        if (settings.showFacets !== undefined && settings.showFacets !== null) this.showFacets = settings.showFacets;
        if (settings.showSearchBar !== undefined && settings.showSearchBar !== null) this.showSearchBar = settings.showSearchBar;
        if (settings.executeSearchOnLoad !== undefined && settings.executeSearchOnLoad !== null) this.executeSearchOnLoad = settings.executeSearchOnLoad;
        if (settings.Page !== undefined && settings.Page !== null) this.Page = settings.Page;
    }
};

var AzureSearchFacetDefinition = function AzureSearchFacetDefinition(settings) {
    classCallCheck(this, AzureSearchFacetDefinition);

    this.title = null;
    this.field = null;
    this.textTop = null;
    this.textBottom = null;
    this.tooltipText = null;
    this.valueType = null;
    this.facetMode = null;
    this.expanded = true;
    this.showMoreAfter = -1;
    this.facetValueOverrides = {};
    this.sliderSettings = {};
    if (settings) {
        if (settings.title) this.title = settings.title;
        if (settings.field) this.field = settings.field;
        if (settings.textTop) this.textTop = settings.textTop;
        if (settings.textBottom) this.textBottom = settings.textBottom;
        if (settings.tooltipText) this.tooltipText = settings.tooltipText;
        if (settings.valueType) this.valueType = settings.valueType;
        if (settings.facetMode) this.facetMode = settings.facetMode;
        if (settings.expanded !== undefined && settings.expanded !== null) this.expanded = settings.expanded;
        if (settings.showMoreAfter !== undefined && settings.showMoreAfter !== null) this.showMoreAfter = setImmediate.showMoreAfter;
        if (settings.facetValueOverrides) this.facetValueOverrides = settings.facetValueOverrides;
        if (settings.sliderSettings) this.sliderSettings = settings.sliderSettings;
    }
};

var AzureSearchSearchSettings = function AzureSearchSearchSettings(settings) {
    classCallCheck(this, AzureSearchSearchSettings);

    this.apiSettings = new AzureSearchApiSettings();
    this.gui = new AzureSearchGui();
    this.searchRequest = new AzureSearchRequest();
    this.facets = [];
    if (settings) {
        if (settings.apiSettings) this.apiSettings = settings.apiSettings;
        if (settings.gui) this.gui = settings.gui;
        if (settings.searchRequest) this.searchRequest = settings.searchRequest;
        if (settings.facets) this.facets = settings.facets;
    }
};

var AzureSearchApi = function () {
    function AzureSearchApi(settings) {
        var _this = this;

        classCallCheck(this, AzureSearchApi);

        this.settings = new AzureSearchSearchSettings();
        if (settings) this.settings = new AzureSearchSearchSettings(settings);

        this.client = axios.create({ baseURL: this.settings.apiSettings.url + '/indexes/' + this.settings.apiSettings.indexName + '/docs' });
        this.client.defaults.headers.common['Content-Type'] = 'application/json';
        this.client.defaults.headers.common['Api-Key'] = this.settings.apiSettings.searchServiceQueryApiKey;
        this.client.defaults.timeout = 0;
        this.client.defaults.method = 'post';

        this.client.interceptors.request.use(function (config) {
            config.url = config.url + '?api-version=' + _this.settings.apiSettings.apiVersion;
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
    }

    createClass(AzureSearchApi, [{
        key: 'search',
        value: function search(searchRequest) {
            var azureSearchRequest = new AzureSearchRequest(searchRequest);
            return this.client.post('/search', azureSearchRequest.getSearchRequestBody());
        }
    }]);
    return AzureSearchApi;
}();

var index = { AzureSearchApiSettings: AzureSearchApiSettings, AzureSearchRequest: AzureSearchRequest, AzureSearchGui: AzureSearchGui, AzureSearchFacetDefinition: AzureSearchFacetDefinition, AzureSearchSearchSettings: AzureSearchSearchSettings, AzureSearchApi: AzureSearchApi };

export default index;
